export default __webpack_public_path__ + "static/media/sticker-education-128.563b2590.png";